import ObjectID from "bson-objectid";

// Generate a new ObjectID as hex string
export function generateObjectId() {
  return ObjectID().toHexString();
}
// Validate if a string is a valid ObjectID
export function isValidObjectId(id) {
  return ObjectID.isValid(id);
}

// Create ObjectID instance from a valid hex string
export function createObjectIdFromHex(hexString) {
  if (!isValidObjectId(hexString)) return null;
  return new ObjectID(hexString);
}

// Extract timestamp from ObjectID
export function getTimestampFromObjectId(id) {
  try {
    const objectId = new ObjectID(id);
    return objectId.getTimestamp(); // returns Date object
  } catch {
    return null;
  }
}

// Sort array of objects by ObjectID creation time
export function sortByObjectIdTimestamp(dataArray, key = "_id", order = "asc") {
  return [...dataArray].sort((a, b) => {
    const timeA = new ObjectID(a[key]).getTimestamp().getTime();
    const timeB = new ObjectID(b[key]).getTimestamp().getTime();
    return order === "asc" ? timeA - timeB : timeB - timeA;
  });
}
